import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=523dbc93&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523dbc93')) {
      api.createRecord('523dbc93', component.options)
    } else {
      api.reload('523dbc93', component.options)
    }
    module.hot.accept("./Step1.vue?vue&type=template&id=523dbc93&", function () {
      api.rerender('523dbc93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/Step1.vue"
export default component.exports